import { query } from "./query"
export const PricingPageQuery = {
    query,
    mocks: {
        defaultData: null,
    },
}
